module.exports = __webpack_public_path__ + "img/wuliu.67837572.png";